import * as React from "react";
import { ICardToolbarAction } from "./Card";
import { Deck, IDeckToolbarSettings } from "./Deck";

export interface ICardToolbarProps {
    deck: Deck;
}

export class CardToolbarComponent extends React.Component<ICardToolbarProps, any> {
    actions: ICardToolbarAction[];
    settings:IDeckToolbarSettings;
    constructor(props: ICardToolbarProps) {
        super(props);
        const actions: ICardToolbarAction[] = [];
        let settings = this.props.deck.toolbarSettings;
        if (!settings) {
            settings = {};
        }
        if (settings.zoom ===undefined ||settings.zoom) {
            actions.push({ title: "Zoom card", icon: "glyphicon glyphicon-eye-open",minNoOfCards:1, action: () => this.props.deck.toggleZoom() });
        }
        if (settings.flip) {
            actions.push({ title: "Flip card", icon: "glyphicon glyphicon-refresh", minNoOfCards: 1, action: () => this.props.deck.flipCard() });
        }
        if (settings.exhaust) {
            actions.push({ title: "Exhaust card", icon: "glyphicon glyphicon-tag", minNoOfCards: 1, action: () => this.props.deck.exhaustCard() });
        }
        if (settings.shuffle) {
            actions.push({ title: "Shuffle deck", icon: "glyphicon glyphicon-random", minNoOfCards: 2, action: () => this.props.deck.shuffleCards() });
        }
        if (settings.randomCardToTop) {
            actions.push({ title: "Pick random card", icon: "glyphicon glyphicon-random", minNoOfCards: 2, action: () => this.props.deck.randomCardToTop() });
        }
        if (settings.navigation) {
            actions.push({ title: "Bottom card to top", icon: "glyphicon glyphicon-chevron-left", minNoOfCards: 2, action: () => this.props.deck.navigateBack() });
            actions.push({ title: "Top card to bottom", icon: "glyphicon glyphicon-chevron-right", minNoOfCards: 2, action: () => this.props.deck.navigateForward() });
        }
        if (settings.addCard) {
            actions.push({ title: "Add card", icon: "glyphicon glyphicon-plus", minNoOfCards: 0,action:()=>this.props.deck.showAddCardSelector()});
        }
        if (settings.removeTopCardFromPlay) {
            actions.push({ title: "Remove card", icon: "glyphicon glyphicon-minus", minNoOfCards: 1, action: () => this.props.deck.removeTopCardFromPlay() });
        }
        if (settings.edit) {
            actions.push({ title: "Edit", icon: "glyphicon glyphicon-pencil", minNoOfCards: 1, action: () => this.props.deck.edit() });
        }
        if (settings.actions) {
            actions.push(...settings.actions);
        }
        this.settings = settings;
        this.actions = actions;
    }
   
  
    render() {

        let actionElements: JSX.Element[] = null;
        if (this.actions.length) {
            actionElements = this.actions.filter(a => !a.minNoOfCards || this.props.deck.noOfCards()>=a.minNoOfCards).map((a, i) => <a key={i} className="btn btn-xs btn-transp" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                a.action();
                return true;
            }} title={a.title}><i className={a.icon}></i></a>);
        }
        let cssName = "toolbar";
        if (this.settings.align) {
            cssName += " " + this.settings.align;
        }
        return (<div className={cssName}>
            {actionElements}
        </div>);
    }
}